import {
  put,
} from 'redux-saga/effects';
import {
  cacheStaticVideos,
} from 'actions/stages';
import { ErrorLog } from 'utils/LoggerItem';

export function* cacheChannelTrailer(channelTrailerUrl) {
  try {
    if (!channelTrailerUrl) {
      throw new ErrorLog('No Channel Trailer Url');
    }
    yield put(cacheStaticVideos({
      channelTrailerUrl,
    }));
  } catch (error) {
    yield put(cacheStaticVideos({
      channelTrailerUrl: '',
    }));
    throw error;
  }
}

export function* cacheMarketingVideo(marketingVideoUrl) {
  try {
    if (!marketingVideoUrl) {
      throw new ErrorLog('No Marketing Video Url');
    }
    yield put(cacheStaticVideos({
      marketingVideoUrl,
    }));
  } catch (error) {
    yield put(cacheStaticVideos({
      marketingVideoUrl: '',
    }));
    throw error;
  }
}
